import React, { useState, useEffect } from "react";
import Seo from "../components/Seo";

// ---- 2026 mock open-exam papers (full paper + mark scheme PDFs) ----
// These are open-exam papers, so they lead the Open Exam Questions list.
const mockPapers2026 = [
  { title: "Clinical Trials", question: "/2026-docs/IRO - Mock Paper 1 - Clinical Trials (Question Paper).pdf", answer: "/2026-docs/IRO - Mock Paper 1 - Clinical Trials (Mark Scheme).pdf" },
  { title: "Genetics", question: "/2026-docs/IRO - Mock Paper 2 - Genetics (Question Paper).pdf", answer: "/2026-docs/IRO - Mock Paper 2 - Genetics (Mark Scheme).pdf" },
  { title: "Enantiomers", question: "/2026-docs/IRO - Mock Paper 3 - Enantiomers (Question Paper).pdf", answer: "/2026-docs/IRO - Mock Paper 3 - Enantiomers (Mark Scheme).pdf" },
  { title: "Spectroscopy", question: "/2026-docs/IRO - Mock Paper 4 - Spectroscopy (Question Paper).pdf", answer: "/2026-docs/IRO - Mock Paper 4 - Spectroscopy (Answer Paper).pdf" },
  { title: "Potassium Isotopes", question: "/2026-docs/IRO - Mock Paper 5 - Potassium Isotopes (Question Paper).pdf", answer: "/2026-docs/IRO - Mock Paper 5 - Potassium Isotopes (Answer Paper).pdf" },
  { title: "Antibody-Drug Conjugates", question: "/2026-docs/IRO - Mock Paper 6 - Antibody-Drug Conjugates (Question Paper).pdf", answer: "/2026-docs/IRO - Mock Paper 6 - Antibody-Drug Conjugates (Mark Scheme).pdf" },
  { title: "Hydrogen Heating", question: "/2026-docs/IRO - Mock Paper 7 - Hydrogen Heating (Question Paper).pdf", answer: "/2026-docs/IRO - Mock Paper 7 - Hydrogen Heating (Mark Scheme).pdf" },
];

// ---- Open Exam practice questions (Google Drive previews) ----
const openQuestions = [
  { id: 1, question: "https://drive.google.com/file/d/158QJX8t9FM0IqQkOJqPJPOiPmdCRQQE2/preview#view=FitH", answer: "https://drive.google.com/file/d/1AkhSgcDSCoSq8RAVuYXPmuK72nwp9722/preview#view=FitH" },
  { id: 2, question: "https://drive.google.com/file/d/1gzHPI0UsMdUDMN6ERRSRbmbYacksxuxS/preview#view=FitH", answer: "https://drive.google.com/file/d/1HKd9WKecnON3jWOljFGt4PsqYp6v494x/preview#view=FitH" },
  { id: 3, question: "https://drive.google.com/file/d/1mWlnvsOxLoTH05w6EI-c4dUHBedISAE8/preview#view=FitH", answer: "https://drive.google.com/file/d/1VOcuQQn_wPrbMLYPO_r57l9o5XEujT0v/preview#view=FitH" },
  { id: 4, question: "https://drive.google.com/file/d/1z9vVHCDOB54Z-ekityXGBj85BXgWC58h/preview#view=FitH", answer: "https://drive.google.com/file/d/1DaS4_ZYsQL8C3y8dVi1j_DphflSYoKQ6/preview#view=FitH" },
  { id: 5, question: "https://drive.google.com/file/d/1cHeuQIj3CmYQwU7tDg7MbVy-FqqYNZCx/preview#view=FitH", answer: "https://drive.google.com/file/d/1fKO-wm4McnwdYCBLJNc5gH9_PfDO8cpP/preview#view=FitH" },
  { id: 6, question: "https://drive.google.com/file/d/1bzMySh29AqcV0kK8n1qScxryhB8F7oap/preview#view=FitH", answer: "https://drive.google.com/file/d/1QSM8XfsLs5Vlphnpm7DhXKqdeiBt3Rtc/preview#view=FitH" },
  { id: 7, question: "https://drive.google.com/file/d/1fhfcD-2FPw3KEBwqmd1-t0Y2BXY_yOno/preview#view=FitH", answer: "https://drive.google.com/file/d/1KFJhObuCxZLD_WTEaXDHQQm9H-YV2N0k/preview#view=FitH" },
  { id: 8, question: "https://drive.google.com/file/d/10HnmmFtcRfpV25DkM19dmUuqHMLcTnXJ/preview#view=FitH", answer: "https://drive.google.com/file/d/139F75DZXD8rV3Ax5mj3ubtIca3wge4pi/preview#view=FitH" },
  { id: 9, question: "https://drive.google.com/file/d/1yrRJSh_RXLRXOT2HfGfzdO6_7KoeNUUN/preview#view=FitH", answer: "https://drive.google.com/file/d/1LdrLCbetQi4tFuKI4I2czyrp-uh3PDYR/preview#view=FitH" },
  { id: 10, question: "https://drive.google.com/file/d/1O5RTcscuG7XEwEh3VnVJPZfR2yFz31oH/preview#view=FitH", answer: "https://drive.google.com/file/d/1E_nUSSXAHmgaOo90ql760c8lwERTpmxR/preview#view=FitH" },
  { id: 11, question: "https://drive.google.com/file/d/1PUnIKqZ-ntGyNvbjNavhX6Xbx9yGdzZD/preview#view=FitH", answer: "https://drive.google.com/file/d/1_5N8HeZBDKjgMlR5ZuSuLjM24rz4HFs2/preview#view=FitH" },
  { id: 12, question: "https://drive.google.com/file/d/1nzV2n86G9-MzYOQKdxIR8eKVmWJnQYq_/preview#view=FitH", answer: "https://drive.google.com/file/d/1X0BAU_G3-uogEWrWjpWvj14hsomwbdn9/preview#view=FitH" },
  { id: 13, question: "https://drive.google.com/file/d/1J6X7K8KmPj45LsfL74PiQ0F6ZP92D6Ih/preview#view=FitH", answer: "https://drive.google.com/file/d/1VD3z-ughgEFh9BwTxCSqxiI1BpDS9pPH/preview#view=FitH" },
  { id: 14, question: "https://drive.google.com/file/d/1PQgtcDTpSuTyJ_IITVmvf4BIF_30-0mF/preview#view=FitH", answer: "https://drive.google.com/file/d/1YSbTOfyeQ3r_Ds5uyEBX5iwqqtZX18Fv/preview#view=FitH" },
  { id: 15, question: "https://drive.google.com/file/d/1Xj9CRB_9x5qR4qxQx27z_C4pFRQik2FT/preview#view=FitH", answer: "https://drive.google.com/file/d/1IYqKbh645xIvGz3d9IaBk5rI4KoYkQ60/preview#view=FitH" },
  { id: 16, question: "https://drive.google.com/file/d/1rSzZcH-SYlprmTERVKSfdNss9TyzgT9j/preview#view=FitH", answer: "https://drive.google.com/file/d/1uInpAu9a3ogZMfaHVTLBPRKUfD5fkYen/preview#view=FitH" },
];

// Open Exam list: the 7 named 2026 mock papers first, then the 16 questions.
const openItems = [
  ...mockPapers2026.map((p) => ({ label: p.title, header: `Mock Paper — ${p.title}`, question: p.question, answer: p.answer })),
  ...openQuestions.map((q) => ({ label: `Question ${q.id}`, header: `Question ${q.id}`, question: q.question, answer: q.answer })),
];

// ---- Semifinal (oral) practice ----
const semiItems = [
  { label: "Mock 1", header: "Semifinal Mock 1", paper: "https://drive.google.com/file/d/1xTXiG1CWnyW0CCbNRjO5b4e33bHgP88w/preview#view=FitH", oral: "Explain the purpose of a superconductor, specifically going into detail about LK-99 and the properties of its electronic structure in making it a superconductor. Discuss if LK-99 holds properties to be used in industrial and medical applications of superconductors and suggest further investigations in the STEM field for LK-99." },
  { label: "Mock 2", header: "Semifinal Mock 2", paper: "https://drive.google.com/file/d/1VKjNHhKWmg4Ao12z06nyUnwPFMvnMPi2/preview#view=FitH", oral: "Discuss the fundamental principles of machine learning and delve into the capabilities of machine learning libraries such as AutoKeras. Provide potential advancements in this technology through future research avenues and its application in optimizing inefficient systems within specific industries." },
  { label: "Mock 3", header: "Semifinal Mock 3", paper: "https://drive.google.com/file/d/1UsD29UaWKBC0W3hu3HFW8SeX7ZPu0BYo/preview#view=FitH", oral: "Evaluate the need for STREAM and its development compared to other measures of impairment, discussing potential uses in conjunction with invasive brain-computer interfaces like Neuralink. Detail an opinion on the use of STREAM and any ideas for further developing this research." },
  { label: "Mock 4", header: "Semifinal Mock 4", paper: "https://drive.google.com/file/d/1Tu9__DQH29WPeeiXV-LB7-_5mIA4IQ4v/preview#view=FitH", oral: "Analyze the process of creating artificial enzymes through multiple active sites by enzyme-metal nanoparticle hybrids. Discuss the potential applications and transferability of these novel enzymes in different industrial sectors and their implications for achieving more environmentally friendly and sustainable chemical processes at scale." },
  { label: "Solutions", header: "Mock Solutions", paper: "https://drive.google.com/file/d/1SVn_CzhD2b3LHtau3nckmVYYYAdXmCze/preview#view=FitH", solutions: true },
];

const MODES = [
  { key: "open", label: "Open Exam Questions" },
  { key: "semi", label: "Semifinal Practice" },
];

const NAVY = "#004d99";

const Frame = ({ title, src }) => (
  <iframe
    title={title}
    src={src}
    style={{ width: "100%", height: "560px", border: "1px solid #e8eef3", borderRadius: "8px" }}
    allow="autoplay"
  />
);

const SubHeading = ({ children }) => (
  <h3 style={{ fontSize: "1rem", fontWeight: 600, color: "#1a1a2e", margin: "0 0 16px 0" }}>{children}</h3>
);

export default function PracticeExams() {
  const [mode, setMode] = useState("open");
  const [selected, setSelected] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const items = mode === "open" ? openItems : semiItems;
  const current = items[selected];

  const switchMode = (key) => {
    setMode(key);
    setSelected(0);
  };

  return (
    <div>
      <Seo
        title="Practice Exams"
        path="/practice-exams"
        description="Prepare for the International Research Olympiad with past Open Exam papers, mock papers with mark schemes, and Semifinal oral practice questions."
      />
      {/* Hero */}
      <div style={{ backgroundColor: "#f8f9fa", padding: "60px 0 50px 0" }}>
        <div className="container">
          <div style={{ maxWidth: "800px" }}>
            <h1 style={{ fontSize: "clamp(2rem, 4vw, 2.5rem)", fontWeight: 700, color: "#1a1a2e", marginBottom: "16px", letterSpacing: "-0.02em" }}>
              Practice Exams
            </h1>
            <p style={{ fontSize: "1.1rem", color: "#555", lineHeight: 1.7 }}>
              Prepare with past IRO papers — open-exam questions and full mock
              papers with mark schemes, plus semifinal oral practice. Each comes
              with its answer key.
            </p>
          </div>
        </div>
      </div>

      <div className="container" style={{ padding: "40px 0 80px 0" }}>
        {/* Mode toggle */}
        <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginBottom: "32px" }}>
          {MODES.map((m) => (
            <button
              key={m.key}
              onClick={() => switchMode(m.key)}
              style={{
                padding: "11px 22px",
                borderRadius: "10px",
                border: mode === m.key ? `2px solid ${NAVY}` : "1px solid #e8eef3",
                backgroundColor: mode === m.key ? NAVY : "#fff",
                color: mode === m.key ? "#fff" : "#555",
                fontWeight: 600,
                fontSize: "0.95rem",
                cursor: "pointer",
                transition: "all 0.2s ease",
              }}
            >
              {m.label}
            </button>
          ))}
        </div>

        {/* Item selector */}
        <div style={{ marginBottom: "24px" }}>
          <p style={{ fontSize: "0.95rem", fontWeight: 600, color: "#1a1a2e", marginBottom: "12px" }}>
            {mode === "open" ? "Select a Paper or Question:" : "Select a Mock:"}
          </p>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
            {items.map((item, index) => (
              <button
                key={item.label}
                onClick={() => setSelected(index)}
                style={{
                  padding: "10px 16px",
                  borderRadius: "8px",
                  border: selected === index ? `2px solid ${NAVY}` : "1px solid #e8eef3",
                  backgroundColor: selected === index ? "rgba(0, 77, 153, 0.08)" : "#fff",
                  color: selected === index ? NAVY : "#555",
                  fontWeight: selected === index ? 600 : 500,
                  fontSize: "0.9rem",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                }}
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>

        {/* Content card */}
        <div style={{ background: "#fff", borderRadius: "16px", overflow: "hidden", boxShadow: "0 4px 20px rgba(0, 0, 0, 0.06)", border: "1px solid #e8eef3" }}>
          <div style={{ padding: "20px 28px", borderBottom: "1px solid #e8eef3", display: "flex", justifyContent: "space-between", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
            <h2 style={{ fontSize: "1.25rem", fontWeight: 600, color: "#1a1a2e", margin: 0 }}>{current.header}</h2>
            {!current.solutions && (
              <span style={{ padding: "6px 14px", borderRadius: "6px", backgroundColor: "rgba(0, 77, 153, 0.08)", color: NAVY, fontSize: "0.85rem", fontWeight: 600 }}>
                Answer Key Below
              </span>
            )}
          </div>

          {/* Open exam: question paper + answer key */}
          {mode === "open" && (
            <>
              <div style={{ padding: "24px" }}>
                <SubHeading>Question Paper</SubHeading>
                <Frame title={`${current.label} questions`} src={current.question} />
              </div>
              <div style={{ padding: "0 24px 24px 24px" }}>
                <SubHeading>Answer Key</SubHeading>
                <Frame title={`${current.label} answers`} src={current.answer} />
              </div>
            </>
          )}

          {/* Semifinal: oral question + paper / solutions */}
          {mode === "semi" && (
            <div style={{ padding: "24px" }}>
              {current.oral && (
                <div style={{ marginBottom: "20px", background: "rgba(0, 77, 153, 0.05)", borderLeft: `4px solid ${NAVY}`, borderRadius: "8px", padding: "16px 20px" }}>
                  <p style={{ margin: 0, fontSize: "0.95rem", color: "#1a1a2e", lineHeight: 1.7 }}>
                    <strong>Mock Oral Question:</strong> {current.oral}
                  </p>
                </div>
              )}
              <SubHeading>{current.solutions ? "Solutions" : "Reading Paper"}</SubHeading>
              <Frame title={current.label} src={current.paper} />
            </div>
          )}
        </div>

        {/* Prev / Next */}
        <div style={{ display: "flex", justifyContent: "space-between", marginTop: "24px" }}>
          <button
            onClick={() => setSelected(Math.max(0, selected - 1))}
            disabled={selected === 0}
            style={{ padding: "12px 24px", borderRadius: "10px", border: "1px solid #e8eef3", backgroundColor: selected === 0 ? "#f8f9fa" : "#fff", color: selected === 0 ? "#999" : "#1a1a2e", fontWeight: 600, fontSize: "0.95rem", cursor: selected === 0 ? "not-allowed" : "pointer" }}
          >
            Previous
          </button>
          <button
            onClick={() => setSelected(Math.min(items.length - 1, selected + 1))}
            disabled={selected === items.length - 1}
            style={{ padding: "12px 24px", borderRadius: "10px", border: "none", backgroundColor: selected === items.length - 1 ? "#ccc" : NAVY, color: "#fff", fontWeight: 600, fontSize: "0.95rem", cursor: selected === items.length - 1 ? "not-allowed" : "pointer" }}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
}
